import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Measure from 'react-measure';
import { HorizontalNav } from 'containers';
import CardRowEmptyState from './CardRowEmptyState';
import * as styles from './CardRow.scss';

var CardRow = /*#__PURE__*/function (_Component) {
  _inherits(CardRow, _Component);

  var _super = _createSuper(CardRow);

  function CardRow(props) {
    var _this;

    _classCallCheck(this, CardRow);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "defaultProps", {
      rowHeight: 216
    });

    _defineProperty(_assertThisInitialized(_this), "handleLeftNav", function () {
      var _this$state = _this.state,
          offset = _this$state.offset,
          outerWidth = _this$state.outerWidth;
      var newOffset = Math.max(0, offset - outerWidth);

      _this.setState({
        offset: newOffset
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRightNav", function () {
      var _this$state2 = _this.state,
          offset = _this$state2.offset,
          innerWidth = _this$state2.innerWidth,
          outerWidth = _this$state2.outerWidth;
      var maxLeft = innerWidth - outerWidth;
      var newOffset = Math.min(maxLeft, offset + outerWidth);

      _this.setState({
        offset: newOffset
      });
    });

    _this.state = {
      offset: 0
    };
    return _this;
  }

  _createClass(CardRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          title = _this$props.title,
          rowHeight = _this$props.rowHeight;
      var showRightNav = this.state.innerWidth && this.state.innerWidth - this.state.offset - 1 > this.state.outerWidth;
      var showLeftNav = this.state.offset > 0;
      var showTitle = title && title.length;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.cardRow,
        style: {
          height: rowHeight
        }
      }, showTitle && /*#__PURE__*/React.createElement("div", {
        className: styles.cardRowTitle
      }, /*#__PURE__*/React.createElement("span", null, title)), items.length ? /*#__PURE__*/React.createElement(HorizontalNav, {
        style: {
          marginTop: 24
        },
        left: '0',
        showLeftNav: showLeftNav,
        showRightNav: showRightNav,
        onLeftNav: function onLeftNav() {
          return _this2.handleLeftNav();
        },
        onRightNav: function onRightNav() {
          return _this2.handleRightNav();
        }
      }, /*#__PURE__*/React.createElement(Measure, {
        onMeasure: function onMeasure(_ref) {
          var width = _ref.width;

          _this2.setState({
            outerWidth: width
          });
        },
        whitelist: ['left', 'width'],
        useClone: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.outerWrap, "\n                ").concat(showLeftNav ? styles.leftShadow : '', "\n                ").concat(showRightNav ? styles.rightShadow : '')
      }, /*#__PURE__*/React.createElement(Measure, {
        onMeasure: function onMeasure(_ref2) {
          var width = _ref2.width;

          _this2.setState({
            innerWidth: width
          });
        },
        whitelist: ['left', 'width'],
        useClone: true
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.innerWrap,
        style: {
          left: -this.state.offset
        }
      }, items.length ? items : ''))))) : /*#__PURE__*/React.createElement(CardRowEmptyState, {
        rowName: title
      }));
    }
  }]);

  return CardRow;
}(Component);

_defineProperty(CardRow, "propTypes", {
  items: PropTypes.arrayOf(PropTypes.node),
  title: PropTypes.string,
  rowHeight: PropTypes.number
});

export { CardRow as default };